import React, { useState, useEffect } from "react";
import { FaCheckCircle, FaInfoCircle, FaBuilding } from "react-icons/fa";
import ArenaProfile from "./arenaProfile";
import axios from "axios";

const DisabledArenas = () => {
  const [disabledArenas, setDisabledArenas] = useState([]);
  const [selectedArena, setSelectedArena] = useState(null);

  const fetchArenas = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/admin-dashboard/disabled-arenas`,
        { withCredentials: true }
      );

      setDisabledArenas(response.data);
    } catch (error) {
      console.error("Error fetching arenas:", error);
    }
  };

  useEffect(() => {
    fetchArenas();
  }, []);

  const handleEnable = async (id) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/admin-dashboard/enable-arena?arenaId=${id}`,
        {},
        { withCredentials: true }
      );

      if (response.status === 200) {
        fetchArenas();
        alert(response.data.message);
      } else {
        alert(response.status + " - " + response.data.message);
      }
    } catch (error) {
      console.error("Error enabling arena:", error);
      alert(
        "Error enabling arena: " + error.response?.data?.message ||
          error.message
      );
    }
  };

  const handleArenaClick = (arena) => {
    setSelectedArena(arena);
  };

  const handleCloseProfile = () => {
    setSelectedArena(null);
  };

  const btnBase =
    "px-4 py-2 border-0 rounded text-white flex items-center text-[0.9rem] transition-colors duration-300";

  return (
    <div className="p-4 max-w-[1200px] mx-auto">
      <h2 className="text-[1.5rem] mb-4">Disabled Arenas</h2>
      {disabledArenas.map((arena) => (
        <div key={arena.id} className="bg-[#f9f9f9] rounded-[8px] p-4 mb-4 flex flex-col md:flex-row justify-between md:items-center cursor-pointer transition-colors duration-300 hover:bg-[#f0f0f0]">
          <div className="flex-1 cursor-pointer" onClick={() => handleArenaClick(arena)}>
            <div className="flex items-center gap-2">
              <h3 className="m-0 text-[1.2rem]">{arena.name}</h3>
              {arena.institute && (
                <FaBuilding
                  className="text-[#3498db]"
                  title={`Associated with Institute: ${arena.institute.name}`}
                />
              )}
            </div>
            <p className="my-2 text-[0.9rem]">{arena.location}</p>
            {arena.institute && (
              <p className="m-0 text-[0.8rem] text-[#6c757d]">
                Institute: {arena.institute.name} ({arena.institute.institute_type_name})
              </p>
            )}
          </div>
          <div className="flex flex-col sm:flex-row gap-2 mt-4 w-full sm:w-auto sm:items-center md:mt-0">
            <button
              onClick={() => handleEnable(arena.id)}
              className={`${btnBase} bg-[#2ecc71] hover:bg-[#27ae60] md:flex-none md:justify-start flex-1 sm:flex-none sm:w-auto justify-center`}
            >
              <FaCheckCircle className="mr-2" /> Enable
            </button>
            <button
              onClick={() => handleArenaClick(arena)}
              className={`${btnBase} bg-[#3498db] hover:bg-[#2980b9] md:flex-none md:justify-start flex-1 sm:flex-none sm:w-auto justify-center`}
            >
              <FaInfoCircle className="mr-2" /> Details
            </button>
          </div>
        </div>
      ))}
      {selectedArena && (
        <ArenaProfile arena={selectedArena} onClose={handleCloseProfile} />
      )}
    </div>
  );
};

export default DisabledArenas;
